import { render, staticRenderFns } from "./CartItemMobile.vue?vue&type=template&id=6dd1b634"
import script from "./CartItemMobile.vue?vue&type=script&lang=js"
export * from "./CartItemMobile.vue?vue&type=script&lang=js"
import style0 from "./CartItemMobile.vue?vue&type=style&index=0&id=6dd1b634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports